import { isValidLurkerEvent } from './validateLurkerEvent'

export class IOSBridge {
  constructor() {
    this.messageHandlers = window?.webkit?.messageHandlers
  }

  getHandler(name) {
    const handler = this.messageHandlers?.[name]
    return handler && typeof handler.postMessage === 'function' ? handler : null
  }

  isWebView() {
    return typeof window !== 'undefined' && !!this.messageHandlers
  }

  onPasswordChanged(success) {
    if (!this.isWebView()) return

    const handler = this.getHandler('onPasswordChanged')
    if (!handler) return

    try {
      handler.postMessage({ success })
    } catch (error) {
      console.error('[IOSBridge] onPasswordChanged failed:', error)
    }
  }

  onPasswordChangeCancel() {
    if (!this.isWebView()) return

    const handler = this.getHandler('onPasswordChangeCancel')
    if (!handler) return

    try {
      handler.postMessage({})
    } catch (error) {
      console.error('[IOSBridge] onPasswordChangeCancel failed:', error)
    }
  }

  showMessage(type, message) {
    if (!this.isWebView()) return

    const handler = this.getHandler('showMessage')
    if (!handler) return

    try {
      handler.postMessage({ type, message })
    } catch (error) {
      console.error('[IOSBridge] showMessage failed:', error)
    }
  }

  goBack() {
    if (!this.isWebView()) return

    const handler = this.getHandler('goBack')
    if (!handler) return

    try {
      handler.postMessage({})
    } catch (error) {
      console.error('[IOSBridge] goBack failed:', error)
    }
  }

  close() {
    if (!this.isWebView()) {
      return
    }

    const handler = this.getHandler('close')

    if (!handler) {
      return
    }

    try {
      handler.postMessage({})
    } catch (error) {
      console.error('[IOSBridge] close failed:', error)
    }
  }

  sendToLurker(event) {
    if (!this.isWebView()) return

    const handler = this.getHandler('sendToLurker')
    if (!handler) return

    if (!isValidLurkerEvent(event)) return

    const { object_name, object_detail, event_type, data, params } = event
    const payload = {
      object_name,
      object_detail,
      event_type,
      data: data ?? {},
      params: params ?? {},
    }

    try {
      handler.postMessage?.(payload)
    } catch (error) {
      console.error('[IOSBridge.sendToLurker] Failed to send message to native handler:', error)
    }
  }
}
